import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Home from './containers/Home';
import StateDashboard from './containers/StateDashboard';
import NotFound from './containers/NotFound';

export default () => (
  <Switch>
    <Route path="/" exact component={Home} />
    <Route path="/state/:stateCode/:story" component={StateDashboard} />
    <Route path="/state/:stateCode" component={StateDashboard} />
    { /* Finally, catch all unmatched routes */}
    <Route component={NotFound} />
  </Switch>
);
